export interface MucPhanDoan {
  giaTri: string;
  nhan: string;
  /** Số nhỏ cạnh nhãn: `Tất cả 12`, `Qua Network 9`. */
  dem?: number;
}

export interface SegmentedControlProps {
  muc: MucPhanDoan[];
  giaTri: string;
  onChange: (giaTri: string) => void;
  'aria-label': string;
}

/**
 * Nhóm nút chọn-một, dính liền nhau trong một khung.
 *
 * Khác `Tabs`: `Tabs` đổi **nội dung cả trang**, cái này **lọc một bảng**. Dùng
 * `radiogroup` chứ không `tablist` vì nó không gắn với panel nào — trình đọc
 * màn hình đọc "chọn 1 trong 3" thay vì "tab 1 của 3".
 */
export function SegmentedControl({
  muc,
  giaTri,
  onChange,
  'aria-label': nhan,
}: SegmentedControlProps) {
  return (
    <div
      role="radiogroup"
      aria-label={nhan}
      className="inline-flex flex-wrap items-center gap-0.5 rounded-o border border-vien bg-neutral-nen p-0.5"
    >
      {muc.map((m) => {
        const chon = m.giaTri === giaTri;
        return (
          <button
            key={m.giaTri}
            type="button"
            role="radio"
            aria-checked={chon}
            onClick={() => {
              onChange(m.giaTri);
            }}
            className={`vung-bam-nho inline-flex items-center gap-1.5 rounded-chip px-3 text-co-ban transition-colors ${
              chon
                ? 'bg-be-mat font-semibold text-chu shadow-[0_1px_2px_rgba(15,23,42,0.08)]'
                : 'text-chu-phu hover:text-chu'
            }`}
          >
            {m.nhan}
            {m.dem !== undefined && (
              <span className={`so-lieu text-phu ${chon ? 'text-chu-phu' : 'text-chu-phu'}`}>
                {m.dem}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
